import { variants } from '../constants/variant'

const disclaimersMap = {
  living: [
    'The images are for illustrative and inspirational purposes only, and may include items not included in the packages.',
    'A representative will get in touch with you shortly after you send your contact details.',
    'Additional customization options are available through the representative.',
    'SparX is not the owner or the seller and has no control over the inventory, quality, price, safety, or any other aspect of the items shown. ',
  ],
  offices: [
    'The images are for illustrative and inspirational purposes only, and may include items not included in the packages.',
    'A desk and chair are provided for each person',
    'SparX is not the owner or the seller and has no control over the inventory, quality, price, safety, or any other aspect of the items shown.',
  ],
  everset: [
    'The images are for illustrative and inspirational purposes only, and may include items not included in the packages.',
    'Additional customization options are available at The Everset website.',
    'SparX is not the owner or the seller and has no control over the inventory, quality, price, safety, or any other aspect of the items shown.',
  ],
  staging: [
    'The furniture, decor, and interior design elements shown are for illustrative and inspirational purposes only. The apartment is offered unfurnished.',
  ],
  staging_perl: [
    'The furniture, decor, and interior design elements shown are for illustrative and inspirational purposes only. The apartment is offered unfurnished.',
    'CORT provides furniture leasing package options for this property. For details and availability, please contact CORT directly.',
  ],
  cort: [
    'The images are for illustrative and inspirational purposes only, and may include items not included in the packages.',
    'Final products may vary but CORT’s expert designers will curate a cohesive look.',
    'Stated prices are for 12-month lease. Prices may vary depending on the lease period.',
    'A CORT representative will get in touch with you within 24 business hours.',
    'Additional customization options are available through CORT representative.',
    'SparX is not the owner or the seller and has no control over the inventory, quality, price, safety, or any other aspect of the items shown.',
  ],
}

export const disclaimersVariantsMap = {
  [variants.df]: disclaimersMap.cort,
  [variants.ctf]: disclaimersMap.df,
  [variants.sw]: disclaimersMap.living,
  [variants.ew]: disclaimersMap.everset,
  [variants.pd]: disclaimersMap.living,
  [variants.of]: disclaimersMap.offices,
  [variants.br]: disclaimersMap.staging,
  [variants.sf]: disclaimersMap.staging,
  [variants.ev]: disclaimersMap.living,
}

export function getDisclaimer(variant, property) {
  if (
    property?.property_name.toLowerCase().includes('demo') ||
    property?.property_name.toLowerCase().includes('northxnorthwest')
  ) {
    return disclaimersMap.staging_perl
  }
  if (property?.property_name.toLowerCase().includes('evoq')) {
    return disclaimersMap.staging
  }
  return disclaimersVariantsMap[variant] || disclaimersMap.living
}
